import { render, staticRenderFns } from "./ClinicalHistory.vue?vue&type=template&id=c6297f4e&scoped=true&"
import script from "./ClinicalHistory.vue?vue&type=script&lang=js&"
export * from "./ClinicalHistory.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalHistory.vue?vue&type=style&index=0&id=c6297f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6297f4e",
  null
  
)

export default component.exports